module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Doettingen_AG-551e99d19614284db8e0895f5a44c755.svg";